export default "__VITE_PUBLIC_ASSET__54f2568c__"